import { store } from "react-recollect";
import { CoiffeurService } from "../../api/service/coiffeur-service";

export const fetchDisciplines = async () => {
  store.disciplines = await CoiffeurService.getDisciplines();
};
